import { render, staticRenderFns } from "./CytologySpecimenView.vue?vue&type=template&id=187f8957&scoped=true&"
import script from "./CytologySpecimenView.vue?vue&type=script&lang=js&"
export * from "./CytologySpecimenView.vue?vue&type=script&lang=js&"
import style0 from "./CytologySpecimenView.vue?vue&type=style&index=0&id=187f8957&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f8957",
  null
  
)

export default component.exports